import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          Table,
          Modal,
          ControlLabel,
          Label,
          ButtonGroup,
          DropdownButton,
          MenuItem,} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loading from "../../components/loading";
import UsersService from "../../services/users-service";
import GLOBALS from '../../utils/Constants';
import {ToastContainer, ToastStore} from 'react-toasts';
import Moment from 'react-moment';
import FormBuilder from 'react-form-builder2';
import FormsService from "../../services/forms-service";
import ArchonFormBuilder from "../../components/archon-form-builder";

class FormBuilderPage extends Component {

  constructor(props, context) {
      super(props, context);
      const credentials =  UsersService.sharedInstance.getStoredCredentials().loginResponse;
      this.state = {
        formName: "Test",//pass this in the url in formBuilder, for receiving PHP to save
        token: credentials.token_data.token,
        auth_username: credentials.data[0].User_ID,
        license: credentials.data[0].User_License,
        sub_user_id: credentials.data[0].recno,
      }
      this.onSave = this.onSave.bind(this);
  }

  render() {
    return <Col>
            <div className="controls-div">
                    <Button className="back-link-btn green-btn" onClick={this.props.back}>Back</Button>
            </div>
            <br/ >
            <ArchonFormBuilder mode={this.props.mode} onSave={this.onSave}
              forms={this.props.forms}
              clients={this.props.clients}
              facilities={this.props.facilities}
              branches={this.props.branches}
              formToEdit={this.props.formToEdit}/>
            <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
          </Col>
  }

  onSave(data) {
    var missingFields = "";
    var isValid = true;
    if(data.facilityId == null) {
      missingFields += "Facility";
      isValid = false;
    }
    if(data.clientId == null) {
      missingFields += missingFields == "" ? "Client" : ", Client";
      isValid = false;
    }
    if(data.branchId == null) {
      missingFields += missingFields == "" ? "Branch" : ", Branch";
      isValid = false;
    }
    if(isValid) {
      let params = {
        "license" : this.state.license,
        "form_name": data.formName,
        "facility_id": data.facilityId,
        "facility_name": data.facilityName,
        "branch_id": data.branchId,
        "branch_name": data.branchName,
        "client_id": data.clientId,
        "client_name": data.clientName,
        "auth_username": this.state.auth_username,
        "token": this.state.token,
        "sub_user_id": this.state.sub_user_id
      };
      params.json_string = data.elements;
      FormsService.sharedInstance.saveCustomForm(params)
      .then((response)=>{
        ToastStore.success("Saving form '" + data.formName + "' success!");
        this.props.updateData();
        // this.props.getAllFormsByLicense();
        //this.props.formDataUpdateData();
      })
      .catch((error)=>{
        console.log("error: ", error);
        ToastStore.error("Saving form '" + data.formName + "' error!", 3500);
      })
    } else {
      ToastStore.error("Saving cancelled. Missing Form data: " + missingFields, 3500);
    }



    //data has Form Name and elements list. we can JSON.stringify it here before passing to API
    //API Call
  }
}

 export default FormBuilderPage
